import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './assets/css/colors.css'
import './assets/css/admin-page-shell.css'
import './assets/css/wallets-ui.css'
import './assets/css/tokens-ci.css'
import './assets/css/tailwind.css'
import './assets/css/motion-global.css'
import { startVersionPolling } from './utils/versionChecker'
import { bootstrapBrandTheme, bootstrapBrandThemeAsync } from './theme/brandTheme'
import { redirectIfUnknownWorkspaceHost } from './utils/workspaceHost'
import { watchHostSessionKey } from './utils/hostScopedStorage'
import ClViewDescription from './components/ds/ClViewDescription.vue'

async function boot() {
  // Wildcard DNS serves this SPA for missing slugs; send them to the platform 404
  // before theme/auth so they never see default Clinch chrome on a fake host.
  const redirected = await redirectIfUnknownWorkspaceHost()
  if (redirected) return

  bootstrapBrandTheme()
  bootstrapBrandThemeAsync()

  const app = createApp(App)
  app.component('ClViewDescription', ClViewDescription)
  app.use(store)
  app.use(router)

  // Restore auth from session before first route so direct URLs (e.g. /dashboard/products)
  // see the correct state and don't redirect to login when already logged in
  await store.dispatch('ensureAuthInit')
  // The session key is shared by every tab on this Host; reload so this tab never keeps
  // the previous user's permissions after a login/logout elsewhere.
  watchHostSessionKey(() => window.location.reload())
  startVersionPolling()
  app.mount('#app')
}

boot()

